import { indexBy } from 'ramda';
import { RestAddressAttributes } from '../../../../hooks/useAddress';

type PlaceResult = google.maps.places.PlaceResult;

export const getAttributesFromPlace = (place: PlaceResult): Partial<RestAddressAttributes> => {
  if (!place.address_components) return {};

  const fieldsByKey = indexBy(component => component.types[0], place.address_components);

  return {
    countryCode: fieldsByKey.country?.short_name,
    postalCode: fieldsByKey.postal_code?.long_name,
    state: fieldsByKey.administrative_area_level_1?.long_name,
    city: fieldsByKey.locality?.long_name,
    addressLine1: [
      fieldsByKey.street_number?.long_name,
      fieldsByKey.route?.long_name,
      fieldsByKey.subpremise?.long_name
    ]
      .filter(Boolean)
      .join(' '),
    addressLine2: fieldsByKey.sublocality_level_1?.long_name
  };
};
